<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h2 class="u">
      Детали клиента
      <router-link class="btn btn-primary" :to="{ name: 'client-edit', params: { client_id: $route.params.client_id }}">Редактировать информацию</router-link>
    </h2>
    <div class="sub-nav">
      <router-link v-if="false" class="btn btn-default btn-sm" :to="{ name: 'apartment-details', params: { apartment_id: $route.params.apartment_id } }">← Назад к Клиентам</router-link>
    </div>

    <clientDetail :client-id="$route.params.client_id" />

  </div>
</template>

<script>
import clientDetail from '@/components/details/client/ClientDetail'

export default {
  name: 'apartment-client-details',
  components: { clientDetail }
}
</script>


// WEBPACK FOOTER //
// ApartmentClientDetails.vue?b7013088